<template>
  <div class="white-bg pr post-head-container">
    <div class="wi-100x ht-100x centerbox centerimage transition-scale z-0" :style="{backgroundImage: 'url('+img+')'}">
      <div style="background-color: rgba(0,0,0,.8);" class="wi-100x ht-100x pa tp-0 lf-0 z-1"></div>
    </div>
    <div class="wrapper pr z-2">
      <el-row>
        <el-col :span="18" :lg="18" :xs="24" :sm="24" class="pr-10">
          <div ref="pageSubTitle" class="tt-u mb-10 pr post-head-subtitle transition-gentle bm--40 op-0 danger" style="letter-spacing: 8px;">{{subtitle}}</div>
          <div ref="pageTitle" class="serif post-head-title pr white transition-gentle bm--80 op-0 fw-600 pl-30 wi-600">{{title}}</div>
        </el-col>
        <el-col :span="6" :lg="6" :xs="24" :sm="24">
          <div class="ht-220 pr lf-30">
            <div ref="introText" class="pa op-0 transition-gentle lf-60 pr-10 bm-60 wi-300">
              <div class="serif post-head-topics white fw-600 tt-u">Topics</div>
              <div class="fs-14 white">{{intro ? intro.replace(/,/g, ' \\ ') : ''}}</div>
            </div>
            <div ref="introLine" class="post-head-line wi-0 transition-lenear ht-1 pa lf white-bg"></div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'postHead',
  props: [
    'title',
    'subtitle',
    'img',
    'intro'
  ],
  computed: {
    ...mapGetters([
      'screenWidth',
      'screenHeight'
    ])
  },
  mounted () {
    setTimeout(() => {
      this.$refs.introText.style.left = 0
      this.$refs.introText.style.opacity = 1
      this.$refs.introLine.style.width = '100px'
      this.$refs.pageTitle.style.opacity = 1
      this.$refs.pageTitle.style.bottom = 0
      this.$refs.pageSubTitle.style.opacity = 1
      this.$refs.pageSubTitle.style.bottom = 0
    }, 500)
  }
}
</script>
<style>
.post-head-title {
  font-size: 2em;
  width: auto;
}
.post-head-subtitle {
  font-size: 14px;
  padding-left: 20px;
}
.post-head-intro {
  font-size: 0.875em;
}
.post-head-topics {
  font-size: 22px;
  margin-bottom: 10px;
}
.post-head-line {
  bottom: 35px;
}
.post-head-container {
  height: 500px;
  padding-top: 120px;
}
@media screen and (min-width: 768px) and (max-width: 992px) {
  .post-head-title {
    font-size: 60px;
    width: 600px;
  }
  .post-head-intro {
    font-size: 15px;
  }
  .post-head-container {
    height: 650px;
    padding-top: 140px;
  }
  .post-head-topics {
    font-size: 24px;
    margin-bottom: 16px;
  }
  .post-head-line {
    bottom: 28px;
  }
}
@media screen and (min-width: 992px) and (max-width: 1200px) {
  .post-head-title {
    font-size: 65px;
    width: 600px;
  }
  .post-head-intro {
    font-size: 15px;
  }
  .post-head-container {
    height: 700px;
    padding-top: 220px;
  }
  .post-head-topics {
    font-size: 24px;
    margin-bottom: 20px;
  }
  .post-head-line {
    bottom: 18px;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1920px) {
  .post-head-title {
    font-size: 70px;
    width: 600px;
  }
  .post-head-intro {
    font-size: 16px;
  }
  .post-head-container {
    height: 700px;
    padding-top: 220px;
    overflow: hidden;
  }
  .post-head-topics {
    font-size: 26px;
    margin-bottom: 20px;
  }
  .post-head-line {
    bottom: 18px;
  }
}
@media screen and (min-width: 1920px) {
  .post-head-title {
    font-size: 60px;
    width: 700px;
  }
  .post-head-intro {
    font-size: 16px;
  }
  .post-head-container {
    height: 700px;
    padding-top: 220px;
    overflow: hidden;
  }
  .post-head-topics {
    font-size: 26px;
    margin-bottom: 20px;
  }
  .post-head-line {
    bottom: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/compos/postHead.vue